import React, { Component } from 'react';
import PageTitle from '../home/PageTitle';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import AgGridComponent from '../common/AgGridComponent';
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../common/PaginationComponent';
import { createMasterActionColumn, createMasterActiveColumn, formatGridAmount } from '../../utils/masterGridHelpers';
import {
    buildMasterGridParams,
    ROOM_CATEGORY_SORT_WHITELIST,
    ROOM_CATEGORY_FILTER_WHITELIST,
} from '../../utils/agGridServerHelpers';
import ApiURL from '../../api/ApiURL';
import cogoToast from 'cogo-toast';
import axios from 'axios';


class RoomCategory extends Component {
    //constructor lifecycle event
    constructor(props) {
        super(props);
        ////register Handsontable's modules
        //registerAllModules();
        this.state = {
            showModal: false,
            showDeleteWarnModal: false,
            tcData: [],
            locationData: [],
            vendorData: [],
            roomCategoryData: [],
            isTableLoading: true,
            currentPage: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            totalRecords: 0,
            columnDefs: [],
            sortModel: [],
            filterModel: {},
            travelCircuitId: 0,
            locationId: 0,
            locationName: '',
            vendorId: 0,
            vendorCategoryId: 1,
            roomCategoryId: 0,
            roomCategoryName: '',
            roomTarrif: 0,
            ebTarrif: 0,
            cnbTarrif: 0,
            userId: 0,
            userRole: '',
            isActive: true
        };
    }
    //componentDidMount lifecycle event
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                userId: userData.UserId,
                userRole: userData.RoleName,
                displayName: userData.DisplayName
            })
        }
        this.getAllTCData();
        this.getAllRoomCategoryData();
        this.getAllDataColumns();
    }
    //Data Reload
    handleReload = () => this.setState({ currentPage: 1 }, this.getAllRoomCategoryData);
    handleSortChange = (sortModel) => {
        this.setState({ sortModel, currentPage: 1 }, this.getAllRoomCategoryData);
    };
    handleFilterChange = (filterModel) => {
        this.setState({ filterModel, currentPage: 1 }, this.getAllRoomCategoryData);
    };
    handlePageChange = (page) => {
        this.setState({ currentPage: page }, this.getAllRoomCategoryData);
    };
    handlePageSizeChange = (size) => {
        this.setState({ pageSize: size, currentPage: 1 }, this.getAllRoomCategoryData);
    };
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        ...this.state,
                        tcData: dataResult,
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //OnChangeHandler
    handleChange = (e) => {
        if (e.target.name === 'travelCircuitId') {
            this.getAllLocationData(e.target.value)
        }
        if (e.target.name === 'locationId') {
            this.getAllVendorData(e.target.value, 1); //1 denotes to Hotel Vendor Category
        }
        this.setState({ [e.target.name]: e.target.value });
    }
    //Get all Location data
    getAllLocationData = (tcId) => {
        axios
            .get(ApiURL.GetAllLocationByTC(tcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    this.setState({ locationData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ locationData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Vendor data
    getAllVendorData = (locId, vcId) => {
        axios
            .get(ApiURL.GetAllVendorByLocation(locId, vcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ vendorData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vendorData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all HotelRoomCategory data
    getAllRoomCategoryData = () => {
        const { currentPage, pageSize, sortModel, filterModel } = this.state;
        const param = buildMasterGridParams(
            currentPage,
            pageSize,
            sortModel,
            filterModel,
            ROOM_CATEGORY_SORT_WHITELIST,
            ROOM_CATEGORY_FILTER_WHITELIST
        );
        this.setState({ isTableLoading: true });
        axios
            .post(ApiURL.GetAllRoomCategory, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        roomCategoryData: dataResult.RoomCategories,
                        totalRecords: dataResult?.TotalRecords ?? 0,
                    });
                } else if (respData.StatusCode === 404) {
                    this.setState({ roomCategoryData: [], totalRecords: 0 });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isTableLoading: false });
            });
    }
    //Get all columns
    getAllDataColumns = () => {
        this.setState({
            columnDefs: [
                createMasterActionColumn(this.getDataItemById, "RoomCategoryId"),
                { headerName: "Travel Circuit", field: "TravelCircuitName", flex: 1, minWidth: 120, cellClass: "text-left" },
                { headerName: "Location", field: "LocationName", flex: 1, minWidth: 120, cellClass: "text-left" },
                { headerName: "Vendor", field: "VendorName", flex: 1, minWidth: 120, cellClass: "text-left" },
                { headerName: "Room Category", field: "RoomCategoryName", flex: 1, minWidth: 120, cellClass: "text-left" },
                { headerName: "Room Tarrif", field: "RoomTarrif", width: 120, cellClass: "text-right", type: "numericColumn", filter: "agNumberColumnFilter", valueFormatter: formatGridAmount },
                { headerName: "EB Tarrif", field: "EBTarrif", width: 110, cellClass: "text-right", type: "numericColumn", filter: "agNumberColumnFilter", valueFormatter: formatGridAmount },
                { headerName: "CNB Tarrif", field: "CNBTarrif", width: 110, cellClass: "text-right", type: "numericColumn", filter: "agNumberColumnFilter", valueFormatter: formatGridAmount },
                createMasterActiveColumn(),
            ],
        })
    }
    //Get data by Id
    getDataItemById = (keyData) => {
        var self = this;
        console.log(keyData);
        axios
            .get(ApiURL.GetRoomCategory(keyData))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    self.setState({
                        roomCategoryId: dataResult.RoomCategoryId,
                        travelCircuitId: dataResult.TravelCircuitId,
                        locationId: dataResult.LocationId,
                        vendorId: dataResult.VendorId,
                        roomCategoryName: dataResult.RoomCategoryName,
                        roomTarrif: dataResult.RoomTarrif,
                        ebTarrif: dataResult.EBTarrif,
                        cnbTarrif: dataResult.CNBTarrif,
                        isActive: dataResult.IsActive,
                        showModal: true,
                    }, () => {
                        self.getAllLocationData(dataResult.TravelCircuitId);
                        self.getAllVendorData(dataResult.LocationId, this.state.vendorCategoryId);
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Open modal
    openModal = () => this.setState({ showModal: true });
    //Close modal
    closeModal = () => this.setState({ showModal: false });
    //Open Delete warning modal
    openWarnModal = () => this.setState({ showDeleteWarnModal: true });
    //Close Delete warning modal
    closeWarnModal = () => this.setState({ showDeleteWarnModal: false });
    //Reset all input fields into the modal
    resetInputFields = () => {
        this.setState({
            showModal: false,
            showDeleteWarnModal: false,
            travelCircuitId: 0,
            locationId: 0,
            locationName: '',
            vendorId: 0,
            vendorCategoryId: 1,
            roomCategoryId: 0,
            roomCategoryName: '',
            roomTarrif: 0,
            ebTarrif: 0,
            cnbTarrif: 0,
            isActive: true
        });
    }
    //Handle Add new Record
    handleAddNew = () => {
        this.resetInputFields();
        this.openModal();
    }
    //Delete data by Id
    handleDelete = () => {
        const { vendorId, roomCategoryId, roomCategoryName, roomTarrif, ebTarrif, cnbTarrif } = this.state;
        let param = {
            RoomCategoryId: roomCategoryId,
            RoomCategoryName: roomCategoryName,
            VendorId: vendorId,
            RoomTarrif: roomTarrif,
            EBTarrif: ebTarrif,
            CNBTarrif: cnbTarrif,
            IsActive: false
        };
        axios.post(ApiURL.SaveRoomCategory, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    cogoToast.success("Vendor deleted successfully!", { position: "bottom-center" });
                    this.resetInputFields();
                    this.closeWarnModal();
                    this.getAllRoomCategoryData();
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //save data
    handleSubmit = (e) => {
        e.preventDefault();
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            //let userId = userData.UserId;
            const { travelCircuitId, locationId, vendorId, roomCategoryId, roomCategoryName, roomTarrif, ebTarrif, cnbTarrif, userId } = this.state;
            if (travelCircuitId === '0') {
                cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
            }
            else if (locationId === '0') {
                cogoToast.error("Location is required!", { position: "bottom-center" });
            }
            else if (vendorId === '0') {
                cogoToast.error("Vendor is required", { position: "bottom-center" });
            }
            else if (roomCategoryName === '') {
                cogoToast.error("Room Category is required", { position: "bottom-center" });
            }
            else {
                let param = {
                    RoomCategoryId: roomCategoryId,
                    RoomCategoryName: roomCategoryName,
                    VendorId: vendorId,
                    RoomTarrif: roomTarrif === '' ? 0 : roomTarrif,
                    EBTarrif: ebTarrif === '' ? 0 : ebTarrif,
                    CNBTarrif: cnbTarrif === '' ? 0 : cnbTarrif,
                    UserId: userId,
                    IsActive: true
                };
                console.log(param);
                axios
                    .post(ApiURL.SaveRoomCategory, param)
                    .then((response) => {
                        let respData = response.data;
                        if (respData.StatusCode === 200) {
                            cogoToast.success("Vendor saved successfully!", { position: "bottom-center" });
                            this.resetInputFields();
                            this.getAllRoomCategoryData();
                        }
                        else if (respData.StatusCode === 500) {
                            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                        }
                    })
                    .catch((error) => {
                        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                    });
            }
        }
    }


    render() {
        const { tcData, locationData, vendorData, roomCategoryData, showModal, showDeleteWarnModal, columnDefs, travelCircuitId,
            locationId, vendorId, roomCategoryId, roomCategoryName, roomTarrif, ebTarrif, cnbTarrif, isActive,
            currentPage, pageSize, totalRecords,
        } = this.state;

        const isAdmin = this.state.userRole === 'admin';
        const isEnabled = isAdmin && isActive && locationId > 0;

        return (
            <>
                <div className="master-page">
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Room Category" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                            <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" onClick={this.handleAddNew}>
                                <i className="fa-solid fa-plus"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="master-page__body">
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / pageSize) || 1}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
                        onPageChange={this.handlePageChange}
                        onPageSizeChange={this.handlePageSizeChange}
                    />
                    <div className="master-page__grid">
                        <AgGridComponent
                            columnDefs={columnDefs}
                            rowData={roomCategoryData}
                            isLoading={this.state.isTableLoading}
                            onSortChange={this.handleSortChange}
                            onFilterChange={this.handleFilterChange}
                            fillHeight
                        />
                    </div>
                </div>
                </div>

                {/* <!----------------- modal section----------------> */}
                <div className={showModal === true ? "modal show-modal  modalWrapper" : "modal"} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title ">{vendorId <= 0 ? `Add Vendor` : `Update Vendor`}</h1>
                                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Travelcircuit <span className='text-danger'>*</span></label>
                                        <select
                                            name="travelCircuitId"
                                            value={travelCircuitId}
                                            className="form-control-sm border border-primary form-select w-100"
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {tcData.map((item, index) => (
                                                <option key={index} value={item.TravelCircuitId}>
                                                    {item.TravelCircuitName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Location <span className='text-danger'>*</span></label>
                                        <select
                                            name="locationId"
                                            value={locationId}
                                            className="form-control-sm border border-primary form-select w-100"
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {locationData.map((item, index) => (
                                                <option key={index} value={item.LocationId}>
                                                    {item.LocationName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label">Hotel Vendor <span className='text-danger'>*</span></label>
                                        <select
                                            name="vendorId"
                                            value={vendorId}
                                            className="form-control-sm border border-primary form-select w-100"
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {vendorData.map((item, index) => (
                                                <option key={index} value={item.VendorId}>
                                                    {item.VendorName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <label className="form-label text-sm">Room Category <span className='text-danger'>*</span></label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="roomCategoryName"
                                            value={roomCategoryName}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Room Tarrif</label>
                                        <input type="number"
                                            className="form-control-sm border border-primary w-100"
                                            name="roomTarrif"
                                            value={roomTarrif}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">EB Tarrif </label>
                                        <input
                                            type="number"
                                            className="form-control-sm border border-primary w-100"
                                            name="ebTarrif"
                                            value={ebTarrif}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">CNB Tarrif</label>
                                        <input type="number"
                                            className="form-control-sm border border-primary w-100"
                                            name="cnbTarrif"
                                            value={cnbTarrif}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button
                                    type="submit"
                                    className="btn btn-success button-box-shadow"
                                    onClick={this.handleSubmit}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> Save
                                </button>
                                {
                                    this.state.userRole === 'admin' &&
                                    <button
                                        type="button"
                                        className={`btn btn-danger button-box-shadow curser-pointer ${roomCategoryId > 0 ? '' : 'disabled'}`}
                                        onClick={() => { roomCategoryId > 0 && this.openWarnModal() }}
                                    >
                                        <i className="fa-solid fa-trash-can"></i> Delete
                                    </button>
                                }
                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!------DELETE Warning Modal--------> */}
                <div className={showDeleteWarnModal === true ? "modal show-modal" : "modal"}>
                    <div className="modal-dialog modal-dialog-centered modal-md ">
                        <div className="modal-content button-box-shadow">
                            <div className="modal-body">
                                <div className="alert alert-warning d-flex align-items-center" role="alert" >
                                    <i className="fa-solid fa-triangle-exclamation"></i>&nbsp;
                                    <div><strong>Are you sure</strong>, you want to <strong>Delete </strong> it?</div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button
                                    type="button"
                                    className="btn btn-danger button-box-shadow btn-sm"
                                    onClick={this.handleDelete}
                                >
                                    <i className="fa-solid fa-trash-can"></i> Delete
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow btn-sm"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeWarnModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default RoomCategory;